import clsx from 'clsx';
import { Content } from 'src/contexts/ContentContext';
import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { Tooltip } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './ComparableListingSeatingDisplay.css';

export type ComparableListingSeatingDisplayProps = {
  section: string;
  row: string | null;
  isYourListing: boolean;
  hideSectionTitle?: boolean;
};

export const ComparableListingSeatingDisplay = ({
  section,
  row,
  isYourListing,
  hideSectionTitle = false,
}: ComparableListingSeatingDisplayProps) => {
  const { isDarkMode } = useSiteTheme();

  const content = (
    <div
      className={clsx(styles.seatingText, {
        [styles.seatingTextHighlighted]: !isDarkMode && isYourListing,
        [styles.seatingTextHighlightedDark]: isDarkMode && isYourListing,
      })}
    >
      <span>
        {section}
        {row && <span>, </span>}
      </span>

      {row && (
        <span>
          <span
            className={clsx(styles.attrLbl, {
              [styles.attrLblHighlighted]: isYourListing,
              [styles.attrLblHighlightedDark]: isDarkMode && isYourListing,
            })}
          >
            <Content id={ContentId.Row} />
          </span>{' '}
          {row}
        </span>
      )}
    </div>
  );

  return (
    <Tooltip
      triggerContent={content}
      contentVariant={isDarkMode ? 'light' : 'dark'}
    >
      <span>
        {section}
        {row && <span>,</span>}
        <span>
          <Content id={ContentId.Row} /> {row}
        </span>
      </span>
    </Tooltip>
  );
};
